<template>
  <v-tooltip top>
    <!-- The highlighted text -->
    <template #activator="{ on }">
      <span
        v-on="on"
        :class="['highlighted-span', feature.color]"
        @mouseenter="expanded = true"
        @mouseleave="expanded = false"
      >
        <span>{{ taggedFeature.value }}</span>
        <!-- A button to trigger a clear of the tagged feature -->
        <v-btn v-if="showClear" @click="remove" color="red" dark icon :style="btnStyle">
          <v-icon small>clear</v-icon>
        </v-btn>
        <!-- A button to trigger the save of the tagged feature -->
        <v-btn v-if="showSave" @click="save" color="green" dark icon :style="btnStyle">
          <v-icon small>check</v-icon>
        </v-btn>
      </span>
    </template>
    <!-- The content of the tooltip -->
    {{feature.name}}
  </v-tooltip>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    /* Set the width and height of the button that clears the tagged feature */
    btnSize: {
      type: Number,
      default: 18
    },
    product: {
      type: Object,
      required: true
    },
    taggedFeature: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    ...mapState("ner", ["features"]),
    /* Computed style to change the size of the buttons */
    btnStyle() {
      return {
        margin: "0 5px",
        height: `${this.btnSize}.px`,
        width: `${this.btnSize}px`
      };
    },
    feature() {
      return this.features.find(f => f.id === this.taggedFeature.featureId);
    },
    showClear() {
      return this.expanded && !this.taggedFeature.notSaved;
    },
    showSave() {
      return this.taggedFeature.notSaved;
    }
  },
  methods: {
    remove() {
      this.$store
        .dispatch("ner/removeTaggedFeatureFromProduct", {
          product: this.product,
          taggedFeature: this.taggedFeature
        })
        .catch(() => {
          this.$notify.error(
            "Lo siento, no pudimos eliminar el tag, intenta en unos segundos por favor."
          );
        });
    },
    save() {
      this.$store
        .dispatch("ner/saveTaggedFeature", {
          product: this.product,
          taggedFeature: this.taggedFeature
        })
        .catch(() => {
          this.$notify.error(
            "Lo sentimos, no pudimos guardar el tag en este momento"
          );
        });
    }
  }
};
</script>

<style scoped>
.highlighted-span {
  border-radius: 5px;
}
</style>